import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function vertriebler() {
	let swiperEl = document.querySelector(".vertrieblerSwiper");

	if (swiperEl) {
		swiperEl.querySelectorAll(".swiper-slide").forEach((slide, i) => {
			if (i % 2 === 0) {
				slide.classList.add("is-even");
			} else {
				slide.classList.add("is-odd");
			}
		});

		const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
		let breakpoints;

		function addClass(cls) {
			swiperEl.classList.add(cls);
			if (swiperEl.previousElementSibling) {
				swiperEl.previousElementSibling.classList.add(cls);
			}
		}

		if (slideCount === 1) {
			addClass("single-slide");
			breakpoints = {
				425: { slidesPerView: 1 },
				768: { slidesPerView: 1 },
				1024: { slidesPerView: 1 },
				1536: { slidesPerView: 1 },
			};
		} else if (slideCount === 2) {
			addClass("two-slides");
			breakpoints = {
				425: { slidesPerView: 1 },
				768: { slidesPerView: 2 },
				1024: { slidesPerView: 2 },
				1536: { slidesPerView: 2 },
			};
		} else if (slideCount === 3) {
			addClass("few-slides");
			breakpoints = {
				425: { slidesPerView: 1 },
				768: { slidesPerView: 2 },
				1024: { slidesPerView: 3 },
				1536: { slidesPerView: 3 },
			};
		} else {
			breakpoints = {
				425: { slidesPerView: 1 },
				768: { slidesPerView: 2 },
				1024: { slidesPerView: 3 },
				1536: { slidesPerView: 4 },
			};
		}

		new Swiper(swiperEl, {
			spaceBetween: 25,
			// modules: [Navigation, Pagination],
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: breakpoints,
		});
	}
}

export { vertriebler };